export const timeKeyArabic = [
  "نهاية السحري",
  "الفجر",
  "الشروق",
  "زوهار",
  "أسار",
  "المغرب",
  "ايشا",
];
